import React, { useState } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Tooltip from "@mui/material/Tooltip";
import { Grid } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FormControlLabel from "@mui/material/FormControlLabel";
import UiInput from "../../_uiComponents/UiInput";
import UiSelect from "../../_uiComponents/UiSelect";
import { UiButton } from "../../../_uiComponents/common/form/UiButton";
import UiSwitch from "../../_uiComponents/UiSwitch";
import UiTableBody from "../../../_uiComponents/common/table/UiTableBody";
import UiTableHead from '../../_uiComponents/UiTableHead';
import UiTableWrapper from "../../../_uiComponents/common/table/UiTableWrapper";
import UiModal from "../../_uiComponents/UiModal";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";

function descendingComparator(a, b, orderBy) {
     if (b[orderBy] < a[orderBy]) {
          return -1;
     }
     if (b[orderBy] > a[orderBy]) {
          return 1;
     }
     return 0;
}

function getComparator(order, orderBy) {
     return order === "desc"
          ? (a, b) => descendingComparator(a, b, orderBy)
          : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
     const stabilizedThis = array.map((el, index) => [el, index]);
     stabilizedThis.sort((a, b) => {
          const order = comparator(a[0], b[0]);
          if (order !== 0) {
               return order;
          }
          return a[1] - b[1];
     });
     return stabilizedThis.map((el) => el[0]);
}

export const NewsFeed = (props) => {
     const [page, setPage] = React.useState(0);
     const [rowsPerPage, setRowsPerPage] = React.useState(8);
     const [order, setOrder] = React.useState("asc");
     const [orderBy, setOrderBy] = React.useState();
     const [active, setActive] = React.useState();
     const [editModal, setEditModal] = React.useState(false);

     const handleEditShow = () => setEditModal(true);
     const handleCloseEdit = () => setEditModal(false);
     const [character, setCharacter] = React.useState("");

     const options1 = [
          { value: "value-1", label: "Sales" },
          { value: "value-2", label: "Sales" },
          { value: "value-3", label: "Sales" },
     ];

     const handleChangetype = (event) => {
          setCharacter(event.target.value);
     };

     //Pagination
     const handleChangePage = (event, newPage) => {
          setPage(newPage);
     };
     const handleChangeRowsPerPage = (event) => {
          setRowsPerPage(+event.target.value);
          setPage(0);
     };

     //Sorting
     const handleRequestSort = (event, property) => {
          const isAsc = orderBy === property && order === "asc";
          setOrder(isAsc ? "desc" : "asc");
          setOrderBy(property);
     };
     const headings = [
          { id: "name", name: "Name" },
          { id: "date", name: "Duration" },
          { id: "comms", name: "Comms Page" },
          { id: "active", name: "Active" },
          { id: "", name: "" },
     ];

     const rows = [
          {
               id: 1,
               name: "New Year Campaign",
               date: "2024-01-01 - 2025-01-01",
               comms: "Comms Page 1",
               enable: true,
          },
          {
               id: 2,
               name: "Hurry up Campaign",
               date: "2024-01-01 - 2025-01-01",
               comms: "Comms Page 2",
               enable: false,
          },
          {
               id: 3,
               name: "New Year Campaign",
               date: "2024-01-01 - 2025-01-01",
               comms: "Comms Page 3",
               enable: true,
          },
     ];

     //Empty rows issue set
     const emptyRows =
          page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

     const [subTableData, setSubTableData] = useState(rows);


     //Data sorting
     const visibleRows = React.useMemo(
          () =>
               stableSort(subTableData, getComparator(order, orderBy)).slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage,
               ),
          [order, orderBy, page, rowsPerPage, subTableData],
     );

     return (
                         <>
                              <div className="sba-table-main-wr">
                                   <UiTableWrapper>
                                        <UiTableHead
                                             headings={headings}
                                             order={order}
                                             orderBy={orderBy}
                                             onRequestSort={handleRequestSort}
                                        />

                                        <UiTableBody>
                                             {visibleRows.map((row, index) => (
                                                  <>
                                                       <TableRow
                                                            key={row.id}
                                                            sx={{
                                                                 "&:last-child td, &:last-child th":
                                                                      {
                                                                           border: "none",
                                                                      },
                                                            }}
                                                       >
                                                            <TableCell align="left">
                                                                 <strong>
                                                                      {row.name}
                                                                 </strong>
                                                            </TableCell>                                                           
                                                            <TableCell align="center">
                                                                      {row.date}
                                                            </TableCell>
                                                            <TableCell align="center" 
                                                                 sx={{
                                                                      color: "blue",
                                                                      cursor: "pointer"
                                                                 }}>
                                                                      {row.comms}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                 <UiSwitch
                                                                 />
                                                            </TableCell>
                                                            <TableCell
                                                                 align="right"
                                                                 sx={{
                                                                      width: "110px",
                                                                 }}
                                                            >
                                                                 <div className="sbt-data-grid__action-bar">
                                                                      <Tooltip
                                                                           title="Preview"
                                                                           placement="top"
                                                                           arrow
                                                                      >
                                                                           <IconButton
                                                                                aria-label="Preview"
                                                                                sx={{
                                                                                     ml: 1.5,
                                                                                }}
                                                                           >
                                                                                <VisibilityIcon />
                                                                           </IconButton>
                                                                      </Tooltip>
                                                                      <Tooltip
                                                                           title="Edit"
                                                                           placement="top"
                                                                           arrow
                                                                      >
                                                                           <IconButton
                                                                                aria-label="Edit"
                                                                                onClick={
                                                                                     handleEditShow
                                                                                }
                                                                                sx={{
                                                                                     ml: 0.5,
                                                                                }}
                                                                           >
                                                                                <EditIcon />
                                                                           </IconButton>
                                                                      </Tooltip>
                                                                      <Tooltip
                                                                           title="Delete"
                                                                           placement="top"
                                                                           arrow
                                                                      >
                                                                           <IconButton
                                                                                aria-label="delete"
                                                                                sx={{
                                                                                     ml: 0.5,
                                                                                }}
                                                                           >
                                                                                <DeleteIcon color="error" />
                                                                           </IconButton>
                                                                      </Tooltip>
                                                                 </div>
                                                            </TableCell>
                                                       </TableRow>                                                      
                                                  </>
                                             ))}
                                             {emptyRows > 0 && (
                                                  <TableRow
                                                       style={{
                                                            height:
                                                                 53 * emptyRows,
                                                       }}
                                                  >
                                                       <TableCell colSpan={6} />
                                                  </TableRow>
                                             )}
                                        </UiTableBody>
                                        <UiModal
                                             handleClose={handleCloseEdit}
                                             open={editModal}
                                             heading="Edit Fact Table"
                                             icon={<EditIcon />}
                                        >
                                             <Grid container spacing={2} mt={2}>
                                                  <Grid
                                                       item
                                                       xs={12}
                                                       lg={6}
                                                       className="sba-search-input"
                                                  >
                                                       <UiInput
                                                            type="text"
                                                            label="Name"
                                                       />
                                                  </Grid>
                                                  <Grid item xs={12} lg={6}>
                                                       <UiSelect
                                                            label="Type"
                                                            value={character}
                                                            handleChange={
                                                                 handleChangetype
                                                            }
                                                            options={options1}
                                                       />
                                                  </Grid>
                                                  <FormControlLabel
                                                       control={<UiSwitch />}
                                                       label="Active"
                                                       labelPlacement="top"
                                                       sx={{ mt: 2 }}
                                                       className="sba-switch-label"
                                                  />
                                             </Grid>
                                             <Grid
                                                  container
                                                  sx={{
                                                       display: "flex",
                                                       mt: 2,
                                                  }}
                                             >
                                                  <UiButton
                                                       name="Reset"
                                                       variant="contained"
                                                       size="large"
                                                       color="error"
                                                  />
                                                  <div className="sbt-right-edit-btn-wr">
                                                       <UiButton
                                                            name="Cancel"
                                                            variant="outlined"
                                                            size="large"
                                                       />
                                                       <UiButton
                                                            name="Add"
                                                            variant="contained"
                                                            size="large"
                                                       />
                                                  </div>
                                             </Grid>
                                        </UiModal>
                                   </UiTableWrapper>
                              </div>
                              <TablePagination
                                   rowsPerPageOptions={[10, 25, 100]}
                                   component="div"
                                   count={rows.length}
                                   rowsPerPage={rowsPerPage}
                                   page={page}
                                   onPageChange={handleChangePage}
                                   onRowsPerPageChange={handleChangeRowsPerPage}
                              />
                         </>
     );
};